// Combined and fixed UTM + gclid parameter tracking script
document.addEventListener('DOMContentLoaded', function() {

    // Function to get the value of a query parameter by name
    function getQueryParam(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    // Function to get all UTM parameters from the URL
    function getUtmParams() {
        const urlParams = new URLSearchParams(window.location.search);
        const utmParams = {};
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(param => {
            const value = urlParams.get(param);
            if (value) {
                utmParams[param] = value;
            }
        });
        return utmParams;
    }

    // Function to update all links with the gclid and UTM parameters
    function updateLinks(params) {
        const links = document.querySelectorAll('a');
        links.forEach(link => {
            const linkHref = link.href;
            try {
                const url = new URL(linkHref);
                Object.keys(params).forEach(key => {
                    url.searchParams.set(key, params[key]);
                });
                link.href = url.toString();
                console.log(`Updated link: ${link.href}`);
            } catch (e) {
                console.error(`Invalid URL: ${linkHref}`, e);
            }
        });
    }

    // Function to update all forms with the gclid and UTM parameters
    function updateForms(params, utmSource, utmMedium, utmCampaign, gclid) {
        const forms = document.querySelectorAll('form');
        forms.forEach(form => {
            // Add gclid and UTM params as regular hidden fields
            Object.keys(params).forEach(key => {
                let input = form.querySelector(`input[name="${key}"]`);
                if (!input) {
                    input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    form.appendChild(input);
                }
                input.value = params[key];
            });

            // Add contact[utm_*] / contact[gclid] fields for form submission
            if (utmSource) {
                let input = form.querySelector(`input[name="contact[utm_source]"]`);
                if (!input) {
                    input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = 'contact[utm_source]';
                    form.appendChild(input);
                }
                input.value = utmSource;
            }
            if (utmMedium) {
                let input = form.querySelector(`input[name="contact[utm_medium]"]`);
                if (!input) {
                    input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = 'contact[utm_medium]';
                    form.appendChild(input);
                }
                input.value = utmMedium;
            }
            if (utmCampaign) {
                let input = form.querySelector(`input[name="contact[utm_campaign]"]`);
                if (!input) {
                    input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = 'contact[utm_campaign]';
                    form.appendChild(input);
                }
                input.value = utmCampaign;
            }
            if (gclid) {
                let input = form.querySelector(`input[name="contact[gclid]"]`);
                if (!input) {
                    input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = 'contact[gclid]';
                    form.appendChild(input);
                }
                input.value = gclid;
            }

            // Update form action URL with parameters (only if form has an action)
            if (form.action) {
                try {
                    const url = new URL(form.action);
                    Object.keys(params).forEach(key => {
                        url.searchParams.set(key, params[key]);
                    });
                    form.action = url.toString();
                } catch (e) {
                    console.error(`Invalid form action URL: ${form.action}`, e);
                }
            }

            console.log(`Updated form:`, form);
        });
    }

    // Function to convert mailto links to "Email Us" buttons that open a form
    function convertMailtoLinksToButtons() {
    const mailtoLinks = document.querySelectorAll('a[href^="mailto:sales@enforcergroup.com.au"]');
    mailtoLinks.forEach(link => {
        // Create a button element
        const button = document.createElement('button');
        button.className = 'email-us-btn';
        button.type = 'button';

        // Add icon and text
        button.innerHTML = `
           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ff580d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px; vertical-align: middle;">
    <rect width="20" height="16" x="2" y="4" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
</svg>
            <span style="vertical-align: middle;color:#ff580d;font-weight:bold;">Email Us</span>
        `;

        // Copy classes from the original link (except mailto-specific ones)
        if (link.className) {
            button.className += ' ' + link.className;
        }

        // Style the button to display icon and text inline
        button.style.alignItems = 'center';

        // Add click handler to open the modal
        button.addEventListener('click', function(e) {
            console.log("btn-clicked");
            e.preventDefault();
            e.stopPropagation();

            // Open the modal-contact-email modal
            const modal = document.querySelector('#modal-contact-email');

            if (modal) {
                // Set the open attribute to match the CSS selector [open]
                modal.setAttribute('open', '');

                // Focus on the modal for accessibility
                const modalWindow = modal.querySelector('.modal__window');
                if (modalWindow) {
                    modalWindow.focus();
                }
                console.log('Opened contact email modal');
            } else {
                console.error('Modal #modal-contact-email not found');
            }
        });

        // Replace the link with the button
        link.parentNode.replaceChild(button, link);
        console.log(`Converted mailto link to "Email Us" button`);
    });
}

    // Function to update popup request form elements
    function updatePopupRequestForm() {
        const popupRequestForm = document.querySelectorAll('.open-popupRequestForm');
        popupRequestForm.forEach(element => {
            console.log("Updated PopUp element:", element);
            // Keep the open-popupRequestForm class for the click functionality
            // Remove href if it's an anchor tag
            if (element.tagName === 'A') {
                element.removeAttribute('href');
            }
        });
    }

    // Main execution
    let gclid = getQueryParam('gclid');
    let utmParams = getUtmParams();

    // Check if UTM params exist in URL, if not check memory storage
    if (Object.keys(utmParams).length === 0) {
        // Try to retrieve from a temporary in-memory object (session-based)
        if (window.sessionUTMParams) {
            utmParams = window.sessionUTMParams;
        }
    } else {
        // Store UTM params in memory for the session
        window.sessionUTMParams = utmParams;
    }

    // Persist gclid the same way: use URL value, else fall back to session memory
    if (gclid !== null) {
        window.sessionGclid = gclid;
    } else if (window.sessionGclid) {
        gclid = window.sessionGclid;
    }

    const utmSource = utmParams.utm_source || null;
    const utmMedium = utmParams.utm_medium || null;
    const utmCampaign = utmParams.utm_campaign || null;

    // If gclid exists, update everything
    if (gclid !== null) {
        const params = { ...utmParams, gclid };
        console.log(`Parameters: ${JSON.stringify(params)}`);
        updateLinks(params);
        updateForms(params, utmSource, utmMedium, utmCampaign, gclid);
        convertMailtoLinksToButtons();
        // Update popup request form periodically
        setInterval(updatePopupRequestForm, 1000);
    }
    // Even without gclid, if we have UTM params, update forms
    else if (Object.keys(utmParams).length > 0) {
        console.log(`UTM Parameters: ${JSON.stringify(utmParams)}`);
        updateForms(utmParams, utmSource, utmMedium, utmCampaign, null);
    }
});

// jQuery form submission handler
jQuery(document).ready(function () {
    // Retrieve stored UTM parameters + gclid from session memory
    const sessionParams = window.sessionUTMParams || {};
    let utmSource = sessionParams.utm_source;
    let utmMedium = sessionParams.utm_medium;
    let utmCampaign = sessionParams.utm_campaign;
    let gclid = window.sessionGclid;

    console.log('Retrieved UTM Source:', utmSource);
    console.log('Retrieved UTM Medium:', utmMedium);
    console.log('Retrieved UTM Campaign:', utmCampaign);
    console.log('Retrieved gclid:', gclid);

    // Handle form submission
    jQuery('.form').on('submit', function (e) {
        var formData = jQuery(this).serializeArray();

        // Store form data temporarily in memory
        window.tempFormData = formData;

        let utmSource = '';
        let utmMedium = '';
        let utmCampaign = '';
        let gclid = '';

        formData.forEach(function (field) {
            if (field.name === 'utm_source' || field.name === 'contact[utm_source]') {
                utmSource = field.value;
            }
            if (field.name === 'utm_medium' || field.name === 'contact[utm_medium]') {
                utmMedium = field.value;
            }
            if (field.name === 'utm_campaign' || field.name === 'contact[utm_campaign]') {
                utmCampaign = field.value;
            }
            if (field.name === 'gclid' || field.name === 'contact[gclid]') {
                gclid = field.value;
            }
        });

        // Update session memory
        if (!window.sessionUTMParams) {
            window.sessionUTMParams = {};
        }
        if (utmSource) window.sessionUTMParams.utm_source = utmSource;
        if (utmMedium) window.sessionUTMParams.utm_medium = utmMedium;
        if (utmCampaign) window.sessionUTMParams.utm_campaign = utmCampaign;
        if (gclid) window.sessionGclid = gclid;

        // Log the values
        console.log('UTM Source:', utmSource);
        console.log('UTM Medium:', utmMedium);
        console.log('UTM Campaign:', utmCampaign);
        console.log('gclid:', gclid);
    });
});